module.exports = __webpack_public_path__ + "media/images/menu/csm_germany-5b3764801b4cf7ebf47649445a21f468.png";